export default {
      id: "i-square-usage",
      viewBox: "0 0 99 99",
      url: __webpack_public_path__ + "img/sprite.svg#i-square",
      toString: function () {
        return this.url;
      }
    }